import React, { useEffect } from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router";
import StoryService from "../../services/story.service";
import TrainingService from "../../services/training.service";


const TrainingDetail = () => {
  const [trainingDetail,setTrainingDetail]=React.useState({});
  const params=useParams();
  console.log("param",params);

    // const relatedStories=[
    //     {poster:"../img/story/poster-1.png"},
    //     {poster:"../img/story/poster-2.png"},
    //     {poster:"../img/story/poster-1.png"},
    // ]

    React.useEffect(()=>{
      TrainingService.detail(params.slug)
      .then(res=>setTrainingDetail(res?.data))
      .catch(err=>console.log(err));
    },[]);

  return (
    <>
      <Header />
      <Breadcrumb pageTitle={trainingDetail?.title} />
      <section className="container py-4">
        <div>
          <h2 className="display-4 text-center text-black fw-bold my-3">
           <strong style={{color:"#FE7743"}} className="fw-semibold">{trainingDetail?.title}</strong>
          </h2>
          {/* <p className="fs-5 m-auto my-4 col-md-11 text-center" dangerouslySetInnerHTML={{__html:storyDetail?.description}}></p> */}
        </div>

        <div className="position-relative py-4">
         <img src={trainingDetail?.featureImgUrl} className=" w-100"/>
        </div>

        <p className="fs-5 m-auto my-4 col-md-11 text-center" dangerouslySetInnerHTML={{__html:trainingDetail?.description}}></p>

      </section>
      <FooterTwo />
    </>
  );
};

export default TrainingDetail;
